module.exports = __webpack_public_path__ + "img/ileti.661e07f0.svg";